(function(){
	 
	var showItem = function(sectionItem){
		var localizedebook = new localizedEbook();
		var item = sectionItem.getAttribute("data-section-item");
        	var itemInfo = JSON.parse(item);

		if(itemInfo.SwagProductImage && itemInfo.SwagProductImage !== '')
		{		
			document.getElementById("productImage").src = itemInfo.ProductImage;
        		document.getElementById("productImage").alt = itemInfo.ProductName;
        		document.getElementById("extraProductImage").src =  itemInfo.SwagProductImage;
        		document.getElementById("extraProductImage").setAttribute('data-src', itemInfo.SwagProductImage);
        		document.getElementById("extraProductImage").alt = itemInfo.ProductName;
        		
        		if(itemInfo.ProductImage && itemInfo.ProductImage !==''){
        			document.getElementById("extraProdImageCont").classList.add('inlineTop');
        			document.getElementById("extraProdImageCont").classList.remove('hide');   
        		}else{
        			document.getElementById("extraProdImageCont").classList.add('hide');
        			document.getElementById("extraProdImageCont").classList.remove('inlineTop');
        		}
			
		}else{
			document.getElementById("productImage").src = itemInfo.ProductImage;
        	      document.getElementById("productImage").alt = itemInfo.ProductName;
        	      document.getElementById("extraProductImage").src = "";
        		document.getElementById("extraProductImage").alt ="";
        	      document.getElementById("extraProdImageCont").classList.add('hide');
        	      document.getElementById("extraProdImageCont").classList.remove('inlineTop');
        	      
	     		
		}

        	document.getElementById("customerName").innerHTML = itemInfo.CustName;
        	document.getElementById("customerLocation").innerHTML = itemInfo.CustLocation;
        	document.getElementById("productName").innerHTML = itemInfo.ProductName;
        	document.getElementById("productAlias").innerHTML = itemInfo.CatAlias;
        	document.getElementById("customerTestimony").innerHTML = itemInfo.CustTestimony;
        	document.getElementById("sectionItemNumber").innerHTML = sectionItem.getAttribute("data-position");
            document.getElementById("shopBtn").href = itemInfo.ProductShopUrl;
            document.getElementById("twitUrl").href = localizedebook.TwitUrl + itemInfo.SectionItemShareUrl;
            document.getElementById("pinUrl").href = localizedebook.PinUrl + itemInfo.SectionItemShareUrl  +"&media=" + itemInfo.ProductImage + "&description=" +itemInfo.CustName + " from " + itemInfo.CustLocation + " describes how they used a 4imprint promotional product! - " + itemInfo.CustTestimony;
            document.getElementById("linkedUrl").href = localizedebook.LinkedUrl + itemInfo.SectionItemShareUrl;
            document.getElementById("fbOnClick").onclick = null;
             document.getElementById("fbOnClick").onclick = function(e){localizedebook.FbFunc(itemInfo.SectionItemShareUrl); e.preventDefault();};
            document.getElementById('itemDetails').scrollIntoView({
		  behavior: 'smooth'
		});
	};
	
	
	var ebookSections = [].slice.call(document.querySelectorAll(".item"));
	ebookSections.forEach(function(el, index, array){
		el.addEventListener("click", function(e){
			showItem(el); 
		});
		el.addEventListener("keyup", function(e){
			if(e.which == 13){
				el.click();
			}
		});
	});
})();